// Categories with sub-categories for marketplace filters
export const filterCategories = [
  { value: "byggnadsvirke", label: "Byggnadsvirke", subs: ["Golv", "Innerpanel", "Lister", "Reglar", "Vindskivor", "Ytterpanel"] },
  { value: "flis", label: "Flis", subs: [] },
  { value: "kutterspån", label: "Kutterspån", subs: [] },
  { value: "pellets", label: "Pellets", subs: [] },
  { value: "plankor", label: "Plankor", subs: ["Hyvlad", "Kantad", "Okantad", "Råsågad"] },
  { value: "rundvirke", label: "Rundvirke", subs: ["Massaved", "Stockmattor", "Stopl & Slanor", "Sågtimmer"] },
  { value: "snickerivirke", label: "Snickerivirke", subs: ["Möbelvirke", "Slöjdvirke"] },
  { value: "sågspån", label: "Sågspån", subs: [] },
  { value: "träd", label: "Träd", subs: [] },
  { value: "ved", label: "Ved", subs: [] },
];

// Map a marketplace category to the internal listing type that controls
// which specification fields (ålder, diameter, fuktkvot, bearbetningsgrad) are shown.
export const categoryToListingType: Record<string, "trad" | "plankor" | "ved"> = {
  byggnadsvirke: "plankor",
  flis: "ved",
  kutterspån: "ved",
  pellets: "ved",
  plankor: "plankor",
  rundvirke: "trad",
  snickerivirke: "plankor",
  sågspån: "ved",
  träd: "trad",
  ved: "ved",
};

export const filterSpecies = [
  "Al", "Alm", "Ask", "Asp", "Björk", "Bok", "Ek", "Ene", "Furu", "Gran", "Lärk", "Lind", "Lönn", "Sälg", "Tall"
].sort();

export const filterMoisture = ["< 16–18%", "> 20%", "> 24–30%"];

// Swedish provinces (landskap) with their municipalities
export const filterProvinces: { name: string; municipalities: string[] }[] = [
  { name: "Blekinge", municipalities: ["Karlshamn", "Karlskrona", "Olofström", "Ronneby", "Sölvesborg"] },
  { name: "Bohuslän", municipalities: ["Kungälv", "Lysekil", "Munkedal", "Orust", "Sotenäs", "Stenungsund", "Strömstad", "Tanum", "Tjörn", "Uddevalla", "Öckerö"] },
  { name: "Dalarna", municipalities: ["Avesta", "Borlänge", "Falun", "Gagnef", "Hedemora", "Leksand", "Ludvika", "Malung-Sälen", "Mora", "Orsa", "Rättvik", "Smedjebacken", "Säter", "Vansbro", "Älvdalen"] },
  { name: "Dalsland", municipalities: ["Bengtsfors", "Dals-Ed", "Färgelanda", "Mellerud", "Åmål"] },
  { name: "Gotland", municipalities: ["Gotland"] },
  { name: "Gästrikland", municipalities: ["Gävle", "Ockelbo", "Sandviken"] },
  { name: "Halland", municipalities: ["Falkenberg", "Halmstad", "Hylte", "Kungsbacka", "Laholm", "Varberg"] },
  { name: "Hälsingland", municipalities: ["Bollnäs", "Hudiksvall", "Ljusdal", "Nordanstig", "Ovanåker", "Söderhamn"] },
  { name: "Härjedalen", municipalities: ["Härjedalen"] },
  { name: "Jämtland", municipalities: ["Berg", "Bräcke", "Krokom", "Ragunda", "Strömsund", "Åre", "Östersund"] },
  { name: "Lappland", municipalities: ["Arjeplog", "Arvidsjaur", "Dorotea", "Gällivare", "Jokkmokk", "Kiruna", "Lycksele", "Malå", "Pajala", "Sorsele", "Storuman", "Vilhelmina", "Åsele", "Överkalix", "Övertorneå"] },
  { name: "Medelpad", municipalities: ["Sundsvall", "Timrå", "Ånge"] },
  { name: "Norrbotten", municipalities: ["Boden", "Haparanda", "Kalix", "Luleå", "Piteå", "Älvsbyn"] },
  { name: "Närke", municipalities: ["Askersund", "Degerfors", "Hallsberg", "Kumla", "Laxå", "Lekeberg", "Ljusnarsberg", "Nora", "Örebro"] },
  { name: "Skåne", municipalities: ["Bjuv", "Bromölla", "Burlöv", "Båstad", "Eslöv", "Helsingborg", "Hässleholm", "Höganäs", "Hörby", "Höör", "Klippan", "Kristianstad", "Kävlinge", "Landskrona", "Lomma", "Lund", "Malmö", "Osby", "Perstorp", "Simrishamn", "Sjöbo", "Skurup", "Staffanstorp", "Svalöv", "Svedala", "Tomelilla", "Trelleborg", "Vellinge", "Ystad", "Åstorp", "Ängelholm", "Örkelljunga", "Östra Göinge"] },
  { name: "Småland", municipalities: ["Alvesta", "Aneby", "Eksjö", "Gislaved", "Gnosjö", "Hultsfred", "Jönköping", "Lessebo", "Ljungby", "Markaryd", "Mullsjö", "Nässjö", "Oskarshamn", "Sävsjö", "Tingsryd", "Tranås", "Uppvidinge", "Vaggeryd", "Vetlanda", "Vimmerby", "Värnamo", "Växjö", "Älmhult"] },
  { name: "Södermanland", municipalities: ["Eskilstuna", "Flen", "Gnesta", "Katrineholm", "Nyköping", "Oxelösund", "Strängnäs", "Trosa", "Vingåker"] },
  { name: "Stockholm", municipalities: ["Botkyrka", "Danderyd", "Ekerö", "Haninge", "Huddinge", "Järfälla", "Lidingö", "Nacka", "Norrtälje", "Nykvarn", "Nynäshamn", "Salem", "Sigtuna", "Sollentuna", "Solna", "Stockholm", "Sundbyberg", "Södertälje", "Tyresö", "Täby", "Upplands Väsby", "Upplands-Bro", "Vallentuna", "Vaxholm", "Värmdö", "Österåker"] },
  { name: "Uppland", municipalities: ["Enköping", "Heby", "Håbo", "Knivsta", "Tierp", "Uppsala", "Älvkarleby", "Östhammar"] },
  { name: "Värmland", municipalities: ["Arvika", "Eda", "Filipstad", "Forshaga", "Grums", "Hagfors", "Hammarö", "Karlstad", "Kil", "Kristinehamn", "Munkfors", "Storfors", "Sunne", "Säffle", "Torsby", "Årjäng"] },
  { name: "Västerbotten", municipalities: ["Bjurholm", "Nordmaling", "Norsjö", "Robertsfors", "Skellefteå", "Umeå", "Vindeln", "Vännäs"] },
  { name: "Västergötland", municipalities: ["Ale", "Alingsås", "Bollebygd", "Borås", "Essunga", "Falköping", "Grästorp", "Gullspång", "Göteborg", "Götene", "Habo", "Herrljunga", "Hjo", "Karlsborg", "Lerum", "Lidköping", "Lilla Edet", "Mark", "Mariestad", "Mölndal", "Partille", "Skara", "Skövde", "Svenljunga", "Tibro", "Tidaholm", "Tranemo", "Trollhättan", "Töreboda", "Ulricehamn", "Vara", "Vårgårda", "Vänersborg"] },
  { name: "Västmanland", municipalities: ["Arboga", "Fagersta", "Hallstahammar", "Kungsör", "Köping", "Norberg", "Sala", "Skinnskatteberg", "Surahammar", "Västerås"] },
  { name: "Ångermanland", municipalities: ["Härnösand", "Kramfors", "Sollefteå", "Örnsköldsvik"] },
  { name: "Öland", municipalities: ["Borgholm", "Mörbylånga"] },
  { name: "Östergötland", municipalities: ["Boxholm", "Finspång", "Kinda", "Linköping", "Mjölby", "Motala", "Norrköping", "Söderköping", "Vadstena", "Valdemarsvik", "Ydre", "Åtvidaberg", "Ödeshög"] },
];

export interface MarketplaceFilters {
  categories: string[];
  subCategories: string[];
  species: string[];
  moisture: string[];
  provinces: string[];
  municipalities: string[];
  priceRange: [number, number];
  ageRange: [number, number];
  search: string;
}

export const defaultFilters: MarketplaceFilters = {
  categories: [],
  subCategories: [],
  species: [],
  moisture: [],
  provinces: [],
  municipalities: [],
  priceRange: [0, 50000],
  ageRange: [0, 600],
  search: "",
};
